import { Chip, IconButton, Button } from "@material-ui/core";
import { columnTextField } from "utils/tables-utils";
import ToolkitTable from "components/Cards/Tables/ToolkitTable";
import { Edit, Add } from "@mui/icons-material";

export default function TableRules({
  data,
  page,
  sizePerPage,
  totalRegistros,
  onTableChange,
  onAction,
  extraActions,
}) {
  const columnModel = [
    columnTextField({
      dataField: "Nome",
      text: "Nome da Regra",
      align: "left",
    }),
    columnTextField({
      dataField: "NomeTipoCobranca",
      text: "Tipo",
      align: "center",
    }),
    columnTextField({
      dataField: "Percentual",
      text: "Percentual",
      align: "center",
    }),
    columnTextField({
      dataField: "Vigencia",
      text: "Vigência",
      align: "center",
    }),
    columnTextField({
      dataField: "Status",
      text: "Status",
      align: "center",
      formatter: (_, row) => {
        return (
          <Chip
            label={row.Ativo ? "Ativo" : "Inativo"}
            size="small"
            style={{
              width: "100px",
              padding: "1rem 0.5rem",
              backgroundColor:
                row.Ativo
                  ? "rgba(0, 128, 0, 0.1)"
                  : "rgba(128, 128, 128, 0.1)",
              border:
                row.Ativo
                  ? "1px solid rgba(0, 128, 0, 0.5)"
                  : "1px solid rgba(128, 128, 128, 0.5)",
            }}
          />
        );
      },
    }),
    columnTextField({
      dataField: "Ações",
      text: "Ações",
      align: "center",
      formatter: (_, row) => {
        return (
          <IconButton
            color="primary"
            onClick={() => onAction(row)}
            size="small"
            style={{ cursor: "pointer" }}
          >
            <Edit fontSize="small" color="textPrimary" />
          </IconButton>
        );
      },
    }),
  ];

  return (
    <ToolkitTable
      dataTable={data}
      searched={Boolean(data)}
      keyField={"IdRegra"}
      headerTitle="Administração de Taxas"
      extraActions={
        <Button variant="contained" color="primary" onClick={extraActions}>
          <Add /> Criar Regra
        </Button>
      }
      columnModel={columnModel}
      notFoundTitle="Sua pesquisa não encontrou nenhum resultado correspondente."
      pagination={{
        options: [25, 50, 100],
        totalSize: totalRegistros,
        page: page + 1,
        sizePerPage: sizePerPage,
        showTotal: true,
      }}
      bootstrapTableProps={{
        remote: true,
        onTableChange: onTableChange,
      }}
    />
  );
}
